import React from "react";
import "./Footer.css";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <div className="footer-inner">
                <span className="footer-text">
                    © {year} · Powered by <strong>Vidyarjana</strong>
                </span>
            </div>
        </footer>
    );
};

export default Footer;